export default "__VITE_ASSET__CHQWg22e__"